// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .privacyPage {
  margin: 5em;
  font-family: "Times New Roman", Times, serif;
}

.privacyPage h2 {
  text-align: center;
} */

.privacy_privacyPage__jE9qx {
  margin: 5vw; /* relative to viewport width instead of fixed em */
  font-family: "Times New Roman", Times, serif;
  padding: 1rem; /* optional padding for small screens */
  box-sizing: border-box; /* ensures padding/margin doesn't break layout */
}

.privacy_privacyPage__jE9qx h2 {
  text-align: center;
  font-size: 2rem; /* scalable heading */
}

/* Optional: adjust margin/font for smaller screens */
@media (max-width: 768px) {
  .privacy_privacyPage__jE9qx {
    margin: 3vw;
    font-size: 0.9rem;
  }

  .privacy_privacyPage__jE9qx h2 {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .privacy_privacyPage__jE9qx {
    margin: 2vw;
    font-size: 0.8rem;
  }

  .privacy_privacyPage__jE9qx h2 {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/PRIVACY_PAGE/privacy.module.css"],"names":[],"mappings":"AAAA;;;;;;;GAOG;;AAEH;EACE,WAAW,EAAE,mDAAmD;EAChE,4CAA4C;EAC5C,aAAa,EAAE,uCAAuC;EACtD,sBAAsB,EAAE,gDAAgD;AAC1E;;AAEA;EACE,kBAAkB;EAClB,eAAe,EAAE,qBAAqB;AACxC;;AAEA,qDAAqD;AACrD;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* .privacyPage {\n  margin: 5em;\n  font-family: \"Times New Roman\", Times, serif;\n}\n\n.privacyPage h2 {\n  text-align: center;\n} */\n\n.privacyPage {\n  margin: 5vw; /* relative to viewport width instead of fixed em */\n  font-family: \"Times New Roman\", Times, serif;\n  padding: 1rem; /* optional padding for small screens */\n  box-sizing: border-box; /* ensures padding/margin doesn't break layout */\n}\n\n.privacyPage h2 {\n  text-align: center;\n  font-size: 2rem; /* scalable heading */\n}\n\n/* Optional: adjust margin/font for smaller screens */\n@media (max-width: 768px) {\n  .privacyPage {\n    margin: 3vw;\n    font-size: 0.9rem;\n  }\n\n  .privacyPage h2 {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .privacyPage {\n    margin: 2vw;\n    font-size: 0.8rem;\n  }\n\n  .privacyPage h2 {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"privacyPage": `privacy_privacyPage__jE9qx`
};
export default ___CSS_LOADER_EXPORT___;
